import { restClient } from 'kineticUtils/api';
import { Buffer } from 'buffer';

const MAX_CAHCE_SIZE = 100;
const imagesCache: Map<string, string> = new Map();

export const getBase64Image = async (path: string, size: string) => {
  const fileKey = path + ':' + size;
  if (imagesCache.has(fileKey)) {
    return imagesCache.get(fileKey);
  }
  const response = await restClient.get(`files/${path}?type=image&${size}`, {
    responseType: 'arraybuffer',
  });

  const base64 = Buffer.from(response.data, 'binary').toString('base64');
  imagesCache.set(fileKey, base64);
  if (imagesCache.size > MAX_CAHCE_SIZE) {
    const diff = imagesCache.size - MAX_CAHCE_SIZE;
    const keys = Array.from(imagesCache.keys());
    keys.forEach((key, index) => {
      if (index < diff) {
        imagesCache.delete(key);
      }
    });
  }
  return base64;
};
